import {observable} from 'mobx';

import {City} from '@/domain/models/City';
import {Country} from '@/domain/models/Country';

class GeoStore {
  readonly cities = observable.map<City['id'], City>();
  readonly countries = observable.map<Country['id'], Country>();

  cleanUp() {
    this.cities.clear();
  }

  setCities(cities: City[]) {
    this.cities.replace(cities.map((city) => [city.id, city]));
  }

  deleteCityById(id: number) {
    this.cities.delete(id);
  }

  addCities(cities?: City[]) {
    if (!cities || cities.length === 0) {
      return;
    }

    this.cities.merge(cities.map((city) => [city.id, city]));
  }

  addCity(city?: City) {
    if (!city || this.cities.has(city.id)) {
      return;
    }

    this.cities.set(city.id, city);
  }

  getCityById(id?: number) {
    if (!id) {
      return undefined;
    }

    return this.cities.get(id);
  }

  getCountryById(id?: number) {
    if (!id) {
      return undefined;
    }

    return this.countries.get(id);
  }

  addCountries(countries?: Country[]) {
    if (!countries || countries.length === 0) {
      return;
    }

    this.countries.merge(countries.map((country) => [country.id, country]));
  }
}

export default new GeoStore();
